import React, { Component, useEffect, useState } from "react";
import ComponentChangePasswordMobile from "./ComponentChangePasswordMobile";
import ComponentChangePasswordWeb from "./ComponentChangePasswordWeb";
import { BrowserView, MobileView } from "react-device-detect";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
const ComponentChangePassword = () => {
  const gaEventTracker = useAnalyticsEventTracker("ChangePassword");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Change Password",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <ComponentChangePasswordWeb></ComponentChangePasswordWeb>
      </BrowserView>
      <MobileView>
        <ComponentChangePasswordMobile></ComponentChangePasswordMobile>
      </MobileView>
    </>
  );
};

export default ComponentChangePassword;
